import { formatMessage as devExtremeFormatMessage } from 'devextreme/localization';

export const Localization = {
  formatMessage(key, defaultValue, ignoreDatabaseDefault) {
    if (ignoreDatabaseDefault) {
      var result = devExtremeFormatMessage(key.toUpperCase() + ".CUSTOMALIAS");
      if (result == "true") {
        var result = devExtremeFormatMessage(key.toUpperCase());

        if (result != null && result != undefined && result != "") {
          return result;
        }
      }
    }
    else {
      var result = devExtremeFormatMessage(key.toUpperCase());
      if (result != null && result != undefined && result != "") {
        return result;
      }
    }

    return defaultValue;
  },
  maxLength(key) {
    var fieldLength = devExtremeFormatMessage(key.toUpperCase() + ".FIELDLENGTH");
    if (fieldLength > 0) {
      return fieldLength;
    }

  }
};


